import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";

export default async function getConfigCat(filters = {}) {
  const config = {
    method: "GET",
    url: buildRequestUrl(filters, "config_cat"),
  };

  const response = await athenaClient(config);
  return response.data;
}
